import { apiUrl, apiUrlV2 } from "../constants/apiUrl"
import { liveSupportEnabled, vciPortalEnabled, tdeAuditingEnabled } from "../utilities/featureFlags"
import { completedTransferParams } from "../constants/defaultTransferParams"
import { whiteListEnabled, isWhitelisted } from "../utilities/dealerWhitelist"

const initialState = {
  user: null,
  requestHeaders: null,
  tdeToken: null,
  tdeRequestHeaders: null,
}

const createAuthSlice = (set, get) => ({
  ...initialState,
  webauthnId: null,
  askRegisterBiometric: true,
  loginUser: (userData) => set((state) => ({ user: userData })),
  loginTasks: (user) => {
    if (whiteListEnabled && !isWhitelisted(user)) {
      get().setErrMessage(
        "Unable to login, please contact your Account Manager"
      )
      return
    }

    if (user.type === "VCI" && !vciPortalEnabled) {
      get().setErrMessage(
        "VCI login is currently unavailable"
      )
      return
    }
    get().loginUser(user)
    get().setRequestHeaders(user.token)

    if (user.type === "DealerUser") {
      get().fetchPendingTransfers()
      get().fetchCompletedTransfers(completedTransferParams)
      get().fetchNotifications()
    }

    if (user.type === "AccountManager") {
      get().fetchReminders()
    }

    if (user.type === "AccountManager" || user.type === "VCI" || user.type === "User" || user.type === "Admin") {
      set((state) => ({ selectedBranch: [String(user.portalBranchId)] }))
      get().fetchAuditDealers()

      if (tdeAuditingEnabled) {
        get().fetchTrailerLocations(String(user.portalBranchId))
      }
    }
  },
  logoutUser: () => {
    get().resetAllSlices()
  },
  validateAzureToken: async (accessToken) =>
    fetch(`${apiUrlV2}/omniauth/azure_token_validation`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ accessToken: accessToken }),
    }),
  acceptInvitation: async (body) =>
    fetch(`${apiUrl}/auth/accept-invitation`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }),
  setWebauthnId: (id) => set((state) => ({ webauthnId: id })),
  setAskRegisterBiometric: (arb) =>
    set((state) => ({ askRegisterBiometric: arb })),
  setRequestHeaders: (token) =>
    set((state) => ({
      requestHeaders: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })),
  setTdeRequestHeaders: (token) =>
    set((state) => ({
      tdeToken: token,
      tdeRequestHeaders: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })),
  clearTdeRequestHeaders: () => set((state) => ({ tdeToken: null, tdeRequestHeaders: null })),
  resetAuthSlice: () => set(initialState),
})

export default createAuthSlice
